var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"word-wrap":"break-word","max-width":"14rem"}},[_vm._v(_vm._s(_vm.data.code))])
}
var staticRenderFns = []

export { render, staticRenderFns }